module.exports = "/assets/data/27226563c3e0e59f24c6fe43099056bc-WA8.data.json";